import { mockClient } from "./mockClient"

export type PublicInvoice = {
  token: string
  status: string
  amount_cents: number
  currency: string
  created_at: string | null
  due_date: string | null
  hosted_invoice_url: string | null
  customer: {
    name: string | null
    email: string | null
  }
  description?: string | null
  is_deposit?: boolean | null
  stripe_invoice_id?: string | null
}

export async function fetchPublicInvoice(token: string, demo: boolean): Promise<PublicInvoice> {
  return mockClient.getPublicInvoice(token, demo) as Promise<PublicInvoice>
}
